import { trackSelfDescribingEvent } from '@snowplow/browser-tracker';

import { getEntities, getGTMData } from '@swf/core/analytics/utils';
import type { TrackingContextValue } from '@swf/core/providers/TrackingContext';

/**
 * Fires when an panel is clicked
 */
export interface PanelToggle {
  /**
   * Text within the panel in English.
   */
  panelName: string;
  /**
   * If true, the panel is open. If false, the panel is closed.
   */
  isOpen: boolean;
}

export const panelToggle = (data: PanelToggle, context?: TrackingContextValue) => {
  window.__GTM_DATA_LAYER__?.push({ event: 'panel_toggle', ...data, ...getGTMData(context) });
  trackSelfDescribingEvent({
    event: { schema: 'iglu:com.starsgroup/panel_toggle/jsonschema/1-0-0', data },
    context: getEntities(context)
  });
};
